import React from "react";
import { Overrides } from "baseui/overrides";
import { Radio as BaseRadio, RadioProps } from "baseui/radio";
import { mergeOverrides } from "baseui";
import { Theme } from "../../../../styling/baseui_theme";

export * from "baseui/radio";

const radioOverrides = (dataTest?: string) =>
  ({
    Root: {
      props: dataTest ? { "data-test": dataTest } : {},
      style: ({ $theme }) => ({
        marginTop: "0px",
        marginBottom: $theme.sizing.scale300,
        paddingTop: $theme.sizing.scale0,
        paddingBottom: $theme.sizing.scale0,
      }),
    },
    Label: {
      style: ({ $theme }) => {
        return {
          fontWeight: $theme.typography.ParagraphMedium.fontWeight,
        };
      },
    },
    RadioMarkOuter: {
      style: ({
        $disabled,
        $theme,
        $checked,
        $error,
        $isFocused,
      }: {
        $theme: Theme;
        $disabled: boolean;
        $checked: boolean;
        $error: boolean;
        $isFocused: boolean;
      }) => ({
        backgroundColor: $disabled
          ? $theme.colors.mono400
          : $checked
            ? $theme.colors.accent400
            : $error
              ? $theme.colors.borderNegative
              : $theme.colors.mono600,
        boxShadow: "none",
        position: "relative",
        ...($isFocused
          ? {
              ":before": {
                width: "calc(100% + 4px)",
                height: "calc(100% + 4px)",
                left: "-4px",
                top: "-4px",
                display: "inline-block",
                position: "absolute",
                content: "''",
                border: `2px solid ${$theme.colors.borderAccent}`,
              },
            }
          : {}),
      }),
    },
  }) as Overrides<BaseRadio & { $disabled: boolean; $checked: boolean }>;

export const Radio = ({ overrides, children, ...props }: RadioProps & { dataTest?: string }) => {
  const mergedOverrides = mergeOverrides(
    radioOverrides(props?.dataTest),
    overrides as Overrides<BaseRadio & { $disabled: boolean; $checked: boolean }>,
  );

  return (
    <BaseRadio {...props} overrides={mergedOverrides}>
      {children}
    </BaseRadio>
  );
};

export default Radio;
